module.exports = __webpack_public_path__ + "img/arrow-green-left.8a97b514.svg";